/* bangzo.js v2 - Add to cart / quantity stepper for bz-card (Dawn 16) */
(function () {
  if (customElements.get('bz-add')) return;
  const SECTIONS = 'cart-drawer,cart-icon-bubble';
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function refreshCart(sections, itemCount) {
    if (!sections) return;
    const parse = (html, sel) => {
      const el = new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
      return el ? el.innerHTML : null;
    };
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      const h = parse(sections['cart-icon-bubble'], '.shopify-section');
      if (h !== null) bubble.innerHTML = h;
    }
    const drawer = document.querySelector('cart-drawer');
    const inner = document.getElementById('CartDrawer');
    if (drawer && inner && sections['cart-drawer']) {
      const h = parse(sections['cart-drawer'], '#CartDrawer');
      if (h !== null) inner.innerHTML = h;
      if (typeof itemCount === 'number') drawer.classList.toggle('is-empty', itemCount === 0);
      const overlay = drawer.querySelector('#CartDrawer-Overlay');
      if (overlay && drawer.close) overlay.addEventListener('click', drawer.close.bind(drawer));
    }
  }

  // Total quantity of a variant across all cart lines
  function qtyFor(items, variantId) {
    return (items || []).filter((i) => Number(i.variant_id) === variantId).reduce((s, i) => s + Number(i.quantity || 0), 0);
  }

  // Tell every card on the page about the full cart (keeps duplicates + drawer edits in sync)
  function broadcastCart(items, source) {
    document.dispatchEvent(new CustomEvent('bz:cart', { detail: { items: items || [], source: source || null } }));
  }

  // Re-read the real cart from Shopify and sync all cards
  let syncTimer = null;
  function syncFromServer() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(async () => {
      try {
        const res = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
        if (!res.ok) return;
        const cart = await res.json();
        broadcastCart(cart.items, null);
      } catch (e) { /* network blip: leave cards as they are */ }
    }, 150);
  }

  class BzAdd extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.variantId = Number(this.dataset.variantId);
      this.qty = Number(this.dataset.qty) || 0;
      this.btn = this.querySelector('[data-bz-add]');
      this.step = this.querySelector('[data-bz-step]');
      this.input = this.querySelector('[data-bz-input]');
      this.msg = this.querySelector('[data-bz-msg]');
      if (!this.btn || !this.step || !this.input) return;
      this.btn.addEventListener('click', () => this.add());
      this.querySelector('[data-bz-plus]').addEventListener('click', () => this.set(this.qty + 1));
      this.querySelector('[data-bz-minus]').addEventListener('click', () => this.set(Math.max(0, this.qty - 1)));
      this.input.addEventListener('change', () => this.set(Math.max(0, parseInt(this.input.value, 10) || 0)));
      this._onCart = (e) => {
        if (e.detail.source === this || this.classList.contains('is-busy')) return;
        const q = qtyFor(e.detail.items, this.variantId);
        if (q !== this.qty && this.msg) this.msg.textContent = ''; // card corrected itself, old error no longer applies
        this.qty = q;
        this.render();
      };
      document.addEventListener('bz:cart', this._onCart);
    }
    disconnectedCallback() {
      if (this._onCart) document.removeEventListener('bz:cart', this._onCart);
    }
    render() {
      this.input.value = this.qty;
      this.btn.hidden = this.qty > 0;
      this.step.hidden = this.qty === 0;
    }
    validId() {
      if (Number.isFinite(this.variantId) && this.variantId > 0) return true;
      if (this.msg) this.msg.textContent = 'Sorry, this item can’t be added. Please open the product page.';
      return false;
    }
    async request(url, body) {
      if (this.msg) this.msg.textContent = '';
      this.classList.add('is-busy');
      try {
        const res = await fetch(root + url, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(Object.assign(body, { sections: SECTIONS, sections_url: window.location.pathname })),
        });
        let data = {};
        try { data = await res.json(); } catch (e) { /* non-JSON error page */ }
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not update cart. Please try again.');
        return data;
      } finally {
        this.classList.remove('is-busy');
      }
    }
    async add() {
      if (!this.validId()) return;
      try {
        // cart/add.js: variant id as a string is accepted everywhere
        const data = await this.request('cart/add.js', { items: [{ id: String(this.variantId), quantity: 1 }] });
        this.qty = qtyFor(data.items, this.variantId) || 1;
        refreshCart(data.sections);
        const d = document.querySelector('cart-drawer');
        if (d) d.classList.remove('is-empty');
        syncFromServer(); // update any duplicate cards of this product
      } catch (e) {
        if (this.msg) this.msg.textContent = e.message;
      }
      this.render();
    }
    async set(q) {
      if (!this.validId()) return;
      const before = this.qty;
      this.qty = q;
      this.render();
      try {
        // cart/change.js: id MUST be a string (variant id or line key)
        const cart = await this.request('cart/change.js', { id: String(this.variantId), quantity: q });
        this.qty = qtyFor(cart.items, this.variantId);
        refreshCart(cart.sections, cart.item_count);
        broadcastCart(cart.items, this);
      } catch (e) {
        this.qty = before;
        if (this.msg) this.msg.textContent = e.message;
        syncFromServer(); // card may be out of date (e.g. item removed in another tab)
      }
      this.render();
    }
  }
  customElements.define('bz-add', BzAdd);

  // Keep cards in sync when the cart changes elsewhere (drawer, product page, cart page)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => {
      const data = ev && ev.cartData;
      if (data && Array.isArray(data.items) && typeof data.item_count === 'number') broadcastCart(data.items, null);
      else syncFromServer();
    });
  }
  // Back/forward cache: page restored from memory may show old quantities
  window.addEventListener('pageshow', (e) => { if (e.persisted) syncFromServer(); });
})();
